export default {
  translation: {
    permission: {
      member: 'Member',
      group: 'Group',
      department: 'Department',
      teamManagement: 'Team Management',
      membersInTotal: 'members in total',
      createGroup: 'Create group',
      leaveTheTeam: 'Leave the team',
      owner: 'Owner',
      moveDepartment: 'Move department',
      manageMember: 'Manage member',
      createSubDepartment: 'Create sub-department',
      description: 'Description',
      descriptionPlaceholder: 'Please input a description',
      administrator: 'Administrator',
      setAsAdministrator: 'Set as Administrator',
      transferOwner: 'Transfer Owner',
      permissionManagement: 'Permission Management',
      manage: 'Manage',
      collaborator: 'Collaborator',
      team: 'Team',
      addCollaborator: 'Add collaborator',
      readPermission: 'Read permission',
      writePermission: 'Write permission',
      managePermission: 'Manage permission',
      ownerPermission: 'Owner',
      manageCollaborator: 'Manage collaborator',
      permission: 'Permission',
      transferTo: 'Transfer to',
      keepAdministratorPrivileges: 'Keep administrator privileges',
      avatar: 'Avatar',
      deleteConfirmMessage: '{{id}} is being used by {{type}} as follows',
      pleaseShareTheModelFirst:
        'Please share the following knowledge base or model first',
    },
  },
};
